import {
    Tabs,
    TabsContentEU,
    TabsListEU,
    TabsTriggerEU
} from '@/components/common/Tabs';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OverviewTab from './OverviewTab';
import PriceTab from './PriceTab';
import { useStore } from '@/hooks/useStore';
import { COMMON_TYPE } from '@/types/enums';
import { flowResult } from 'mobx';
import { useLocation } from 'react-router-dom';
import { isPathEk } from '@/utils/routes';

export default observer(function BikeDetailTabs() {
    // hook
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    // store
    const {
        capacitieStore: { getCapacitieList },
        priceStore: { getPriceListEnduser },
        optionStore: { getOptionsEnduser },
        generalStore: { getCancelSetting, getOtherSetting }
    } = useStore();

    // state
    const [activeTab, setActiveTab] = useState<string>('overview');

    // lifecycle
    useEffect(() => {
        fetchDataPrices();
    }, []);

    // function
    const handleTabChange = (tabValue: string) => {
        setActiveTab(tabValue);
    };

    const fetchDataPrices = async () => {
        const type = isEk ? COMMON_TYPE.EK : COMMON_TYPE.GAS;

        return Promise.all([
            flowResult(getPriceListEnduser({ type })),
            flowResult(getOptionsEnduser({ type })),
            flowResult(getCapacitieList({ type, sortKey: 'id', sortDir: 'asc' })),
            flowResult(getCancelSetting()),
            flowResult(getOtherSetting())
        ]);
    };

    return (
        <Tabs value={activeTab} onValueChange={handleTabChange} className='w-full'>
            <TabsListEU className='flex justify-center gap-0'>
                <TabsTriggerEU value='overview' className='border-r-0 h-[45px] w-[min(220px,39vw)] sm:h-[60px]'>
                    {t('words_title.overview')}
                </TabsTriggerEU>
                <TabsTriggerEU value='price' className='h-[45px] w-[min(220px,39vw)] sm:h-[60px]'>
                    {t('booking_bike.title.price')}
                </TabsTriggerEU>
            </TabsListEU>
            <TabsContentEU value='overview'>
                <OverviewTab />
            </TabsContentEU>
            <TabsContentEU value='price'>
                <PriceTab />
            </TabsContentEU>
        </Tabs>
    );
});
